export default "__VITE_ASSET__DCIxhIZF__"